var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#E4F0FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call-button"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6548 22.0478C15.6548 22.0478 22.1914 28.0142 25.8753 26.1333C25.8753 26.1333 26.8934 25.2992 26.9921 24.4799C27.0907 23.6605 26.2448 23.1109 25.9179 22.9241C25.1354 22.475 24.3304 22.0565 23.5319 21.6303C23.2795 21.4953 23.0059 21.343 22.7078 21.4177C22.5353 21.4618 22.3575 21.5097 22.1999 21.5844C21.6377 21.8487 21.1767 22.0977 20.5677 22.3457C20.5677 22.3457 19.9461 22.1639 17.6271 20.0523C15.1633 17.8085 15.4963 16.9742 15.4963 16.9742C15.8168 16.5652 16.1085 16.1372 16.3513 15.6861C16.4556 15.4917 16.5993 15.304 16.66 15.0923C16.7218 14.8797 16.5951 14.7275 16.4886 14.5407C16.2522 14.1232 15.9999 13.7133 15.738 13.3082C15.2865 12.6081 14.8255 11.8784 14.2495 11.253C14.1888 11.1879 14.0472 10.9926 13.9311 11.0002C12.6503 11.0778 11.3886 12.2299 11.3886 12.2299C9.40606 15.4898 15.6548 22.0478 15.6548 22.0478Z",
    fill: "#0B5CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallButton);
export default __webpack_public_path__ + "static/media/call-button.8103dcfdb6b7ec39045eb677bb810cb5.svg";
export { ForwardRef as ReactComponent };